import Fund, { FundMetric } from './models'

export default Fund
export { FundMetric }
